//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { resolveBookWordPower, isWordTrialLimited, trialWordLimitToast, TRIAL_WORD_LIMIT } from '@/utils/trialAccess'

export default {
  data () {
    return {
      book: {},
      totalUnitList: [],
      show: false,
      cell: {},
      bookWordPower: 1,
      actions: [
        { name: '看英文选中文', type: '1' },
        { name: '看中文选英文', type: '2' },
        { name: '单词默写', type: '3' },
        { name: '拆分拼写闯关', type: '4' },
        { name: '单词消消乐', type: '5' }
      ]
    }
  },
  computed: {
    isTabMode () {
      return this.$route.path === '/practice'
    },
    bookReady () {
      return !!(this.routeQuery.value || this.book.categoryId)
    },
    routeQuery () {
      if (this.isTabMode) {
        return {
          value: this.book.categoryId,
          label: this.book.categoryName || this.book.label,
          source: 'practice'
        }
      }
      return { ...this.$route.query }
    },
    navTitle () {
      const label = this.book.label || this.book.categoryName || '单词练习'
      return label.length > 14 ? label.substring(0, 14) + '…' : label
    }
  },
  created () {
    this.initPage()
  },
  activated () {
    if (this.isTabMode) {
      this.loadBookFromUser()
    }
  },
  methods: {
    initPage () {
      if (this.isTabMode) {
        this.loadBookFromUser()
        return
      }
      this.book = { ...this.$route.query }
      this.loadUnitList()
    },
    loadBookFromUser () {
      this.$ajax.post(this.$api.getUserInfo, { key: 'studyBookID' }).then(result => {
        this.book = result || {}
        this.loadUnitList()
      })
    },
    goPickBook () {
      this.$router.push({ path: '/wordIndex?hideTrans=true' })
    },
    loadUnitList () {
      const planId = this.routeQuery.value
      if (!planId) {
        this.totalUnitList = []
        this.bookWordPower = 0
        return
      }
      this.$ajax
        .post(this.$api.getUnitListByBookId, { planId })
        .then(result => {
          this.totalUnitList = result || []
          this.bookWordPower = resolveBookWordPower(this.totalUnitList)
        })
    },
    ensurePracticeAccess () {
      if (isWordTrialLimited(this.bookWordPower)) {
        this.$toast(trialWordLimitToast() + `（练习最多${TRIAL_WORD_LIMIT}词）`)
      }
      return true
    },
    buildQuery (extra) {
      return {
        ...this.routeQuery,
        isWordPower: this.bookWordPower,
        ...extra
      }
    },
    practiceTable (type) {
      this.ensurePracticeAccess()
      const query = this.buildQuery({ type })
      delete query.cellId
      delete query.scope
      this.$router.push({ path: '/practiceTable_display', query })
    },
    gotoWordTestAll () {
      this.ensurePracticeAccess()
      const query = this.buildQuery({ scope: 'book' })
      delete query.cellId
      delete query.unitCn
      this.$router.push({ path: '/wordTest_display', query })
    },
    gotoWordSelectAll () {
      this.ensurePracticeAccess()
      const query = this.buildQuery({ scope: 'book' })
      delete query.cellId
      delete query.unitCn
      this.$router.push({ path: '/wordSelect_display', query })
    },
    gotoWordMatchAll () {
      this.ensurePracticeAccess()
      const query = this.buildQuery({ scope: 'book' })
      delete query.cellId
      delete query.unitCn
      this.$router.push({ path: '/wordMatch_display', query })
    },
    goSmartReview () {
      this.$router.push({
        path: '/reviewHome_display',
        query: { categoryId: this.routeQuery.value, isWordPower: this.bookWordPower, from: 'practice' }
      })
    },
    gotoPracticeCell (cell) {
      this.cell = cell
      this.show = true
    },
    practiceCellTable (item) {
      const cellPower = (this.cell && (this.cell.isWordPower === 0 || this.cell.isWordPower === '0'))
        ? 0
        : (this.bookWordPower === 0 ? 0 : 1)
      const query = this.buildQuery({
        cellId: this.cell.id,
        unitCn: this.cell.unitCn || this.cell.unitEn,
        isWordPower: cellPower,
        isPower: this.cell.isPower
      })
      delete query.scope
      if (item.type === '3') {
        delete query.type
        this.$router.push({ path: '/wordTest_display', query })
        return
      }
      if (item.type === '4') {
        delete query.type
        this.$router.push({ path: '/wordSelect_display', query })
        return
      }
      if (item.type === '5') {
        delete query.type
        this.$router.push({ path: '/wordMatch_display', query })
        return
      }
      query.type = item.type
      this.$router.push({ path: '/practiceTable_display', query })
    },
    goReturn () {
      if (this.$route.query.source) {
        this.$router.push({ path: '/home?hideTrans=true' })
        return
      }
      this.$router.push({ path: '/wordIndex?hideTrans=true' })
    },
    goBack () {
      this.$router.push({ path: '/home?hideTrans=true' })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/word/practice/selectList.vue